<div mat-dialog-title>
  <h2>Add New Language</h2>
  <eiq-button
    [title]="'Close add language dialog'"
    [color]="'light'"
    [style]="'icon'"
    [icon]="faClose"
    [disabled]="loading$()"
    testId="add-language-dialog-close"
    class="mat-dialog-title__close"
    (clicked)="onCancel()"
  ></eiq-button>
</div>
<div mat-dialog-content class="add-language-dialog__content">
  <eiq-search-input [(ngModel)]="search$" [placeholder]="'Search languages...'" [debounce]="100" testId="add-language-dialog-language"></eiq-search-input>

  <div class="add-language-dialog__language-list">
    @for (lang of filteredLanguages$(); track lang.code) {
      <eiq-card
        class="add-language-dialog__language-card"
        [class.selected]="selectedLanguage$()?.code === lang.code"
        [clickable]="true"
        [testId]="'add-language-dialog-language-' + lang.code"
        (clicked)="selectedLanguage$.set(lang)"
      >
        <div slot="content" class="add-language-dialog__language">
          <fa-icon [icon]="faGlobe"></fa-icon>
          <div class="add-language-dialog__language-name">
            <span class="fs__sm fw__500">{{ lang.name }}</span>
            <span class="fs__sm native">{{ lang.nativeName }}</span>
          </div>
        </div>
      </eiq-card>
    }
  </div>
</div>
<div mat-dialog-actions class="add-language-dialog__actions">
  <span class="fs__sm fw__500"> {{ languages.length }} available {{ languages.length === 1 ? 'language' : 'languages' }}</span>
  <eiq-button
    [text]="'Cancel'"
    [style]="'stroked'"
    [color]="'light'"
    [disabled]="loading$()"
    testId="add-language-dialog-cancel"
    (clicked)="onCancel()"
  ></eiq-button>
  <eiq-button
    [text]="'Add New Language'"
    [color]="'primary'"
    testId="add-language-dialog-confirm"
    [disabled]="!selectedLanguage$()"
    [loading]="loading$()"
    [loadingText]="'Adding...'"
    (clicked)="onAddLanguage()"
  ></eiq-button>
</div>
